module.exports = __webpack_public_path__ + "static/media/button-loader-cropped.9c9c8e68.gif";